import { render, staticRenderFns } from "./ClientWorkRequestList.vue?vue&type=template&id=375dadca&"
import script from "./ClientWorkRequestList.vue?vue&type=script&lang=ts&"
export * from "./ClientWorkRequestList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports